/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var observable = typeof Symbol === 'function' && Symbol.observable || '@@observable';
//# sourceMappingURL=observable.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/symbol/observable.js
// module id = 155
// module chunks = 1